<app-dialog-header [title]="'general.api_payment_reversal_confirmation_modal_title' | translate"></app-dialog-header>
<mat-dialog-content>
  <app-label-value [label]="'general.api_payment_reversal_confirmation_total_count'" [singleLine]="true" [value]="totalCount | quantityInPcs"></app-label-value>
  <app-label-value [label]="'general.api_payment_reversal_confirmation_total_amount'" [singleLine]="true" [value]="totalAmount | price"></app-label-value>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="buttons"></app-dialog-footer>
<ng-template #buttons>
  <div class="flex flex-end max-width flex-mobile">
    <div class="flex-mobile">
      <button mat-button mat-dialog-close>
        {{'general.api_general_cancel' | translate}}
      </button>
      <button mat-flat-button color="primary" (click)="close(true)">
        {{'general.api_payment_reversal_confirmation_modal_button_ok' | translate}}
      </button>
    </div>
  </div>
</ng-template>
